// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/dist/cjs.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/private_utils.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".markdowneditor-label-7qgPz7mpmwr{}.markdowneditor-wrapper-3YLhBBZVmwr>:last-child{margin-left:3px}", "",{"version":3,"sources":["webpack://client/shared/markdown-editor/markdowneditor.scss"],"names":[],"mappings":"AAEA,kCACE,CAIA,gDACE,eAAA","sourcesContent":["@import \"../styles/variables.scss\";\n\n.label {\n  composes: label from '../styles/private_utils.scss';\n}\n\n.wrapper {\n  > :last-child {\n    margin-left: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1faece",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#f7e28b",
	"violetLight2": "#cec0ec",
	"tealLight3": "#cfece8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"label": "markdowneditor-label-7qgPz7mpmwr " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["label"] + "",
	"wrapper": "markdowneditor-wrapper-3YLhBBZVmwr"
};
export default ___CSS_LOADER_EXPORT___;
